// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IuAJ","toggle":"styles_toggle__3MBD1","preview":"styles_preview__x1D74"};